import { getAuth0ClientId } from '@libs/common-next';
import { getAccessToken } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { auth0Client } from '../clients/auth0-browser-client';
import { CWEA_ENDPOINTS } from '../constants';
import { unwrapApiResponseOrThrow } from './utils';

const AUTH0_CHANGE_PASSWORD_CONNECTION = 'Username-Password-Auth-with-Janrain';

type Auth0ChangePasswordPayload = {
    client_id: string;
    email: string;
    connection: string;
};

export type Auth0VerificationEmailJobResponse = {
    status: string;
    type: string;
    id: string;
    created_at: string;
};

export async function resetAuth0Password(body: { email: string }) {
    await auth0Client.post<Auth0ChangePasswordPayload>('dbconnections/change_password', {
        client_id: getAuth0ClientId(),
        email: body.email,
        connection: AUTH0_CHANGE_PASSWORD_CONNECTION,
    });
}

export async function sendEmailVerification() {
    if (!getAccessToken()) {
        throw new Error('No access token found');
    }

    const response = await cweaClient.post<Auth0VerificationEmailJobResponse, Record<string, never>>(
        CWEA_ENDPOINTS.account.resendEmailVerificationV2,
        { body: {} }
    );

    return unwrapApiResponseOrThrow(response, 'Failed to send verification email');
}
